import { DatePipe } from '@angular/common';
import {
  EnvironmentProviders,
  Provider,
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer
} from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faCommentSms } from '@fortawesome/free-solid-svg-icons';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgOtpInputModule } from 'ng-otp-input';
import { ColorPickerModule } from 'ngx-color-picker';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { shareProp } from '@constants/share-button-constant';
import { PhoneMaskDirective } from '@modules/dynamic-form-builder/directive/phone-mask.directive';
import { SsnMaskDirective } from '@modules/dynamic-form-builder/directive/ssn-mask.directive';
import { SharedPhoneMaskDirective } from '@modules/shared/directive/shared-phone-mask.directive';
import { AbbreviateNumberPipe } from '@shared/pipes/abbreviate-number.pipe';
import { CapitalizeFirstPipe } from '@modules/shared/pipes/capitalizeFirst.pipe';
import { AddressFormattingPipe } from '@modules/shared/pipes/address-formatting.pipe';
import { CurrencyToLocal } from '@shared/pipes/convertCurrencyToLocal.pipe';
import { IsDeductionTransactionPipe } from '@shared/pipes/is-deduction-txn.pipe';
import { isPostCollaboratorPipe } from '@shared/pipes/is-post-collaborator.pipe';
import { MyProfile } from '@shared/pipes/my-profile.pipe';
import { ShowTabByApprovalPipe } from '@shared/pipes/show-tab-by-approval.pipe';

export const SHARED_MODULE_ICONS = [faXTwitter, faCommentSms];

export const SHARE_BUTTONS_OPTIONS = {
  debug: true,
  prop: shareProp
};

export const SHARED_MODULE_PROVIDERS: Provider[] = [
  { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
  SharedPhoneMaskDirective,
  MyProfile,
  isPostCollaboratorPipe,
  DatePipe,
  AbbreviateNumberPipe,
  CapitalizeFirstPipe,
  CurrencyToLocal,
  IsDeductionTransactionPipe,
  ShowTabByApprovalPipe,
  AddressFormattingPipe
];

/**
 * Pipes, directives and third-party module providers that components resolve
 * from the root injector. BsModalService creates modal content with the root
 * injector, so modals opened from any route resolve their dependencies from here.
 */
export function provideSharedRootProviders(): (Provider | EnvironmentProviders)[] {
  return [
    ...SHARED_MODULE_PROVIDERS,
    PhoneMaskDirective,
    SsnMaskDirective,
    importProvidersFrom(
      NgSelectModule,
      NgMultiSelectDropDownModule.forRoot(),
      CarouselModule,
      NgOtpInputModule,
      ColorPickerModule,
      NgCircleProgressModule.forRoot({}),
      ShareButtonsModule.withConfig(SHARE_BUTTONS_OPTIONS),
      ShareIconsModule
    ),
    provideEnvironmentInitializer(() =>
      inject(FaIconLibrary).addIcons(...SHARED_MODULE_ICONS)
    )
  ];
}
